.alert {
  display: flex;
  align-items: center;
  width: 22rem;
  padding: 0.5rem 0.4375rem;
  border: 0.0625rem solid var(--neutral-200);
  border-radius: 99rem;
  background-color: var(--neutral);
  box-shadow: 0 0.5rem 2rem -0.6875rem rgba(0, 0, 0, 0.22);
  animation-name: alertFadeIn;
  animation-duration: 0.2s;
  animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
  animation-fill-mode: forwards;

  @media (min-width: 400px) {
    padding: 0.625rem 0.5rem;
  }

  &.deleted {
    animation-name: alertFadeOut;
  }

  .icon,
  .image {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
  }

  .icon {
    min-height: 3rem;
    margin: 0 0.75rem 0 0.25rem;

    svg {
      width: 2.25rem;
      height: 2.25rem;
      stroke-width: 1.25;
    }
  }

  .image {
    margin: 0 0.9375rem 0 0.125rem;
    border-radius: 99rem;
    overflow: hidden;

    img {
      width: 3.25rem;
      height: 3.25rem;
      object-fit: cover;

      @media (min-width: 400px) {
        width: 3.5rem;
        height: 3.5rem;
      }
    }
  }

  .description {
    margin: 0 auto 0.0625rem 0;

    .title {
      margin: 0 0 0.1875rem;
    }

    .message {
      display: -webkit-box;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .close {
    flex: 0 0 auto;
    align-self: center;
    width: 2.75rem;
    height: 2.75rem;
    margin: 0 0.25rem 0 1rem;
    padding: 0;

    svg {
      width: 1.4375rem;
      height: 1.4375rem;
    }
  }
}

@keyframes alertFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }

  100% {
    opacity: 1;
    transform: none;
  }
}

@keyframes alertFadeOut {
  0% {
    opacity: 1;
    transform: none;
  }

  100% {
    opacity: 0;
    transform: translateY(60%);
  }
}
